<template>
  <div class="hello">
    <el-form ref="fileImgForm" style="background-color: white;" :model="value" label-width="120px" label-suffix=":">
      <el-row  type="flex" style="flex-wrap:wrap;" >
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="样式表设置" prop="cssType">
            <el-select
              v-model="value.cssType" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="false"
            >
              <el-option label="默认样式" value="1"></el-option>
              <el-option label="托福真题" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="试题和题目结构设置" prop="flexType" label-width="150px">
            <el-select
              v-model="value.flexType" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="false"
            >
              <el-option label="上下" value="1"></el-option>
              <el-option label="题目居右" value="2"></el-option>
              <el-option label="题目居左" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="答题卡设置" prop="dtkSet">
            <el-select
              v-model="value.dtkSet" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="false"
            >
              <el-option label="默认显示" value="1"></el-option>
              <el-option label="显示到操作栏中" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="操作栏位置" prop="czlPosition">
            <el-select
              v-model="value.czlPosition" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="false"
            >
              <el-option label="上部" value="1"></el-option>
              <el-option label="下部" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="是否提交前确认" prop="ifConfirm">
            <el-select
              v-model="value.ifConfirm" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="false"
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'QuestionCssSet',
  props: {
    showType: {
      type:Number,
      default:0
    },
    value: {
      type:Object,
      default:{}
    }
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  components: {
  },
  methods: {
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
